/*
 * ARTMiE — mix-and-match configurator (v3, localized).
 * The section renders the hero server-side; this script renders the item grid + live footer
 * and adds the PARENT variant with the hidden _amh_bundle_items property. The Cart Transform
 * expands it server-side at metafield prices — this script never sets a trusted price.
 * Strings come from L10N[cfg.lang] (the Hub writes lang into custom.mix_config per country).
 */
(function () {
  "use strict";
  var L10N = {"sk":{"productsWord":"produkty","choice":"Výber","selected":"Vybrané:","chooseMore":"Vyber si ešte {n}","addSet":"Pridať set do košíka ({n})","adding":"Pridávam…","saving":"Ušetríš {x}","less":"menej","more":"viac"},"cs":{"productsWord":"produktů","choice":"Výběr","selected":"Vybráno:","chooseMore":"Vyber ještě {n}","addSet":"Přidat sadu do košíku ({n})","adding":"Přidávám…","saving":"Ušetříš {x}","less":"méně","more":"více"},"pl":{"productsWord":"produkty","choice":"Wybór","selected":"Wybrano:","chooseMore":"Wybierz jeszcze {n}","addSet":"Dodaj zestaw do koszyka ({n})","adding":"Dodawanie…","saving":"Oszczędzasz {x}","less":"mniej","more":"więcej"},"hu":{"productsWord":"termék","choice":"Választás","selected":"Kiválasztva:","chooseMore":"Válassz még {n} darabot","addSet":"Szett a kosárba ({n})","adding":"Hozzáadás…","saving":"Megtakarításod: {x}","less":"kevesebb","more":"több"},"ro":{"productsWord":"produse","choice":"Alegere","selected":"Selectat:","chooseMore":"Alege încă {n}","addSet":"Adaugă setul în coș ({n})","adding":"Se adaugă...","saving":"Economisești {x}","less":"mai puțin","more":"mai mult"},"sl":{"productsWord":"izdelkov","choice":"Izbira","selected":"Izbrano:","chooseMore":"Izberi še {n}","addSet":"Dodaj komplet v košarico ({n})","adding":"Dodajanje…","saving":"Prihraniš {x}","less":"manj","more":"več"},"hr":{"productsWord":"proizvoda","choice":"Odabir","selected":"Odabrano:","chooseMore":"Odaberi još {n}","addSet":"Dodaj set u košaricu ({n})","adding":"Dodavanje…","saving":"Ušteda {x}","less":"manje","more":"više"},"sr":{"productsWord":"proizvoda","choice":"Izbor","selected":"Izabrano:","chooseMore":"Izaberi još {n}","addSet":"Dodaj set u korpu ({n})","adding":"Dodavanje...","saving":"Ušteda {x}","less":"manje","more":"više"},"bs":{"productsWord":"proizvoda","choice":"Izbor","selected":"Odabrano:","chooseMore":"Odaberi još {n}","addSet":"Dodaj set u korpu ({n})","adding":"Dodavanje…","saving":"Ušteda {x}","less":"manje","more":"više"},"mk":{"productsWord":"производи","choice":"Избор","selected":"Избрано:","chooseMore":"Одбери уште {n}","addSet":"Додај го сетот во кошничка ({n})","adding":"Се додава...","saving":"Заштедуваш {x}","less":"помалку","more":"повеќе"},"bg":{"productsWord":"продукти","choice":"Избор","selected":"Избрани:","chooseMore":"Избери още {n}","addSet":"Добави комплекта в количката ({n})","adding":"Добавяне…","saving":"Спестяваш {x}","less":"по-малко","more":"още"},"el":{"productsWord":"προϊόντα","choice":"Επιλογή","selected":"Επιλεγμένα:","chooseMore":"Επίλεξε {n} ακόμα","addSet":"Προσθήκη σετ στο καλάθι ({n})","adding":"Προσθήκη…","saving":"Κερδίζεις {x}","less":"λιγότερα","more":"περισσότερα"},"it":{"productsWord":"prodotti","choice":"Scelta","selected":"Selezionati:","chooseMore":"Scegline altri {n}","addSet":"Aggiungi set al carrello ({n})","adding":"Aggiunta in corso...","saving":"Risparmi {x}","less":"meno","more":"altro"},"de":{"productsWord":"Produkte","choice":"Auswahl","selected":"Ausgewählt:","chooseMore":"Wähle noch {n} weitere","addSet":"Set in den Warenkorb ({n})","adding":"Wird hinzugefügt…","saving":"Du sparst {x}","less":"weniger","more":"mehr"}};
  var CTA = {"sk":{"choose":"Vybrať produkty","view":"Zobraziť produkt"},"cs":{"choose":"Vybrat produkty","view":"Zobrazit produkt"},"pl":{"choose":"Wybierz produkty","view":"Zobacz produkt"},"hu":{"choose":"Válogass","view":"Megtekintés"},"ro":{"choose":"Alege produsele","view":"Vezi produsul"},"sl":{"choose":"Izberi izdelke","view":"Ogled izdelka"},"hr":{"choose":"Odaberi proizvode","view":"Pregledaj"},"sr":{"choose":"Izaberi proizvode","view":"Pogledaj proizvod"},"bs":{"choose":"Odaberi proizvode","view":"Pregledaj proizvod"},"mk":{"choose":"Избери производи","view":"Види производ"},"bg":{"choose":"Избери продукти","view":"Виж продукта"},"el":{"choose":"Επιλέξτε προϊόντα","view":"Προβολή"},"it":{"choose":"Scegli i tuoi prodotti","view":"Vedi prodotto"},"de":{"choose":"Produkte wählen","view":"Ansehen"}};
  var TRIES = [0, 600, 1500, 3000, 6000];
  TRIES.forEach(function (ms) { setTimeout(init, ms); });

  function fmt(s, vars) {
    return String(s || "").replace(/\{(\w+)\}/g, function (_, k) { return vars[k] != null ? vars[k] : "{" + k + "}"; });
  }

  function init() {
    var el = document.getElementById("amh-mix");
    var cfgEl = document.getElementById("amh-mix-cfg");
    if (!el || !cfgEl || el.dataset.amhMixDone) return;
    el.dataset.amhMixDone = "1";

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!cfg || !cfg.slots || !cfg.slots.length) return;
    var parentVariant = Number(el.dataset.parentVariant || 0);
    if (!parentVariant) return;

    var T = L10N[cfg.lang] || L10N.bs;
    var C = CTA[cfg.lang] || CTA.bs;
    var ccy = (el.dataset.currency === "BAM" ? "KM" : el.dataset.currency) || "";
    var fixed = cfg.mode === "fixed_total" && cfg.totalPrice > 0;
    var min = Math.max(1, Number(cfg.minItems || 1));
    var max = Math.min(20, Number(cfg.maxItems || 20));
    // One-variant-per-product: the customer may pick at most one variant of the same product
    // (e.g. one size of a canvas). Each pick is a toggle (max qty 1) and choosing a variant
    // clears any sibling of the same product. pid comes from cfg.slots[].items[].pid.
    var onePerProduct = cfg.oneVariantPerProduct === true;
    var qty = {};
    var pidOf = {};
    var cardByGid = {};

    var style = document.createElement("style");
    style.textContent = 'form[action*="/cart/add"]:not(.amh-mix-form){ display:none !important; }';
    document.head.appendChild(style);

    var wrap = document.createElement("div");
    wrap.className = "amh-mixw";
    wrap.innerHTML =
      "<style>" +
      ".amh-mixw__slot{margin:16px 0 8px;font-weight:700;font-size:1.02rem;display:flex;align-items:center;gap:8px}" +
      ".amh-mixw__slot em{font-style:normal;font-size:.78rem;font-weight:600;color:#8a8a8a}" +
      ".amh-mixw__grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(152px,1fr));gap:10px}" +
      ".amh-mixw__item{background:#fff;border:1px solid #eee7dd;border-radius:12px;padding:10px;text-align:center;transition:border-color .15s ease, box-shadow .15s ease}" +
      ".amh-mixw__item--on{border-color:#EF56A9;box-shadow:0 4px 14px rgba(239,86,169,.15)}" +
      ".amh-mixw__item img{width:100%;aspect-ratio:1;object-fit:contain;border-radius:8px;background:#fdfbf8}" +
      ".amh-mixw__link{display:block;text-decoration:none;color:inherit;cursor:pointer;position:relative}" +
      ".amh-mixw__link:hover .amh-mixw__t{color:#EF56A9}" +
      ".amh-mixw__view{display:block;font-size:.68rem;color:#2456c9;margin-top:2px;opacity:.85}" +
      ".amh-mixw__link:hover .amh-mixw__view{text-decoration:underline}" +
      ".amh-choosecta{display:block;width:100%;background:linear-gradient(90deg,#F95523,#EF56A9);color:#fff;border:none;border-radius:999px;padding:15px 24px;font-weight:800;font-size:1.05rem;cursor:pointer;margin:10px 0;box-shadow:0 6px 18px rgba(239,86,169,.28)}" +
      ".amh-mixw__t{font-size:.8rem;line-height:1.3;margin:6px 0 2px;min-height:2.4em}" +
      ".amh-mixw__vt{display:inline-block;background:#eef4ff;color:#2456c9;font-size:.72rem;font-weight:700;padding:1px 8px;border-radius:999px;margin-bottom:4px}" +
      ".amh-mixw__p{font-size:.85rem}.amh-mixw__p b{color:#1c1c1c}.amh-mixw__p s{color:#999;font-size:.78rem;margin-left:4px}" +
      ".amh-mixw__q{display:flex;align-items:center;justify-content:center;gap:8px;margin-top:6px}" +
      ".amh-mixw__q button{width:30px;height:30px;border-radius:999px;border:1px solid #ddd;background:#fff;font-size:1.05rem;cursor:pointer;line-height:1}" +
      ".amh-mixw__q span{min-width:18px;font-weight:700}" +
      ".amh-mixw__foot{position:sticky;bottom:10px;display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;margin-top:18px;padding:14px 16px;background:#fff;border:1px solid #eee7dd;border-radius:14px;box-shadow:0 8px 26px rgba(0,0,0,.09)}" +
      ".amh-mixw__cnt{font-size:.9rem;color:#6b6b6b}.amh-mixw__cnt b{color:#1c1c1c}" +
      ".amh-mixw__totwrap{text-align:right}" +
      ".amh-mixw__tot{font-size:1.3rem;font-weight:800}" +
      ".amh-mixw__save{display:block;font-size:.8rem;color:#0a7d38;font-weight:700}" +
      ".amh-mixw__cta{background:linear-gradient(90deg,#F95523,#EF56A9);color:#fff;border:none;border-radius:999px;padding:14px 28px;font-weight:700;font-size:1rem;cursor:pointer}" +
      ".amh-mixw__cta[disabled]{opacity:.5;cursor:default}" +
      "</style>" +
      '<div class="amh-mixw__slots"></div>' +
      '<div class="amh-mixw__foot">' +
      '<span class="amh-mixw__cnt"></span>' +
      '<span class="amh-mixw__totwrap"><span class="amh-mixw__tot"></span><span class="amh-mixw__save"></span></span>' +
      '<button type="button" class="amh-mixw__cta"></button>' +
      "</div>";

    // Items that are VARIANTS OF THE SAME PRODUCT all carry the identical product title, so the grid
    // reads as one product printed N times and the customer can't tell the options apart ("I can't
    // choose between them"). Count titles across every slot: where a title repeats, the VARIANT name
    // (colour/size) is the real identity, so lead the card with it. Per-item, so mixed bundles —
    // some products repeated, some unique — still render correctly.
    var titleCount = {};
    cfg.slots.forEach(function (s) {
      (s.items || []).forEach(function (i) { var t = i.title || ""; titleCount[t] = (titleCount[t] || 0) + 1; });
    });

    var slotsEl = wrap.querySelector(".amh-mixw__slots");
    cfg.slots.forEach(function (slot) {
      var h = document.createElement("div");
      h.className = "amh-mixw__slot";
      // If every item in this slot is the same product, name it ONCE in the heading so the shared
      // product name isn't lost when the cards switch to variant-first labels.
      var uniq = {};
      (slot.items || []).forEach(function (i) { uniq[i.title || ""] = 1; });
      var keys = Object.keys(uniq);
      var sharedTitle = keys.length === 1 && keys[0] ? keys[0] : "";
      h.innerHTML = esc(sharedTitle || slot.label || T.choice) + " <em>" + (slot.items || []).length + " " + esc(T.productsWord) + "</em>";
      slotsEl.appendChild(h);
      var grid = document.createElement("div");
      grid.className = "amh-mixw__grid";
      (slot.items || []).forEach(function (it) {
        qty[it.gid] = 0;
        pidOf[it.gid] = it.pid || "";
        var card = document.createElement("div");
        card.className = "amh-mixw__item";
        var _lo = it.handle ? '<a class="amh-mixw__link" href="/products/' + esc(it.handle) + '" target="_blank" rel="noopener" title="' + esc(C.view) + '">' : "";
        var _lc = it.handle ? '<span class="amh-mixw__view">' + esc(C.view) + " ↗</span></a>" : "";
        // Repeated product + a variant name ⇒ the variant IS the choice: show it as the card title
        // and drop the now-redundant variant badge.
        var variantFirst = !!(it.vt && titleCount[it.title || ""] > 1);
        card.innerHTML =
          _lo +
          (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : "") +
          '<div class="amh-mixw__t">' + esc(variantFirst ? it.vt : it.title) + "</div>" +
          _lc +
          (!variantFirst && it.vt ? '<span class="amh-mixw__vt">' + esc(it.vt) + "</span><br>" : "") +
          '<span class="amh-mixw__p"><b>' + money(it.dprice) + "</b>" + (it.price > it.dprice ? "<s>" + money(it.price) + "</s>" : "") + "</span>" +
          '<div class="amh-mixw__q"><button type="button" data-d="-1" aria-label="' + esc(T.less) + '">−</button><span>0</span><button type="button" data-d="1" aria-label="' + esc(T.more) + '">+</button></div>';
        card.querySelectorAll(".amh-mixw__q button").forEach(function (b) {
          b.addEventListener("click", function () {
            var cur = qty[it.gid] || 0;
            var next = Math.max(0, cur + Number(b.dataset.d));
            if (total() - cur + next > max) return; // total-unit cap only — any quantity of ONE variant is fine
            // One-variant-per-product: picking a variant clears any already-chosen SIBLING variant of the
            // same product (can't have two sizes of one canvas), but the chosen variant's quantity is free.
            if (onePerProduct && next > 0 && it.pid) {
              Object.keys(qty).forEach(function (g) {
                if (g !== it.gid && qty[g] > 0 && pidOf[g] === it.pid) {
                  qty[g] = 0;
                  var sib = cardByGid[g];
                  if (sib) { sib.querySelector(".amh-mixw__q span").textContent = "0"; sib.classList.remove("amh-mixw__item--on"); }
                }
              });
            }
            qty[it.gid] = next;
            card.querySelector(".amh-mixw__q span").textContent = String(next);
            card.classList.toggle("amh-mixw__item--on", next > 0);
            recompute();
          });
        });
        cardByGid[it.gid] = card;
        grid.appendChild(card);
      });
      slotsEl.appendChild(grid);
    });

    var priceOf = {}, retailOf = {};
    cfg.slots.forEach(function (s) { (s.items || []).forEach(function (i) { priceOf[i.gid] = Number(i.dprice) || 0; retailOf[i.gid] = Number(i.price) || 0; }); });

    function total() { return Object.keys(qty).reduce(function (n, k) { return n + qty[k]; }, 0); }
    function money(n) { return (Math.round(Number(n) * 100) / 100).toFixed(2) + (ccy ? " " + ccy : ""); }

    var cntEl = wrap.querySelector(".amh-mixw__cnt");
    var totEl = wrap.querySelector(".amh-mixw__tot");
    var saveEl = wrap.querySelector(".amh-mixw__save");
    var cta = wrap.querySelector(".amh-mixw__cta");
    function recompute() {
      var n = total();
      var sum = 0, retail = 0;
      Object.keys(qty).forEach(function (k) { sum += qty[k] * priceOf[k]; retail += qty[k] * retailOf[k]; });
      if (fixed && n === min) sum = Number(cfg.totalPrice);
      cntEl.innerHTML = esc(T.selected) + " <b>" + n + "</b> / " + (fixed ? min : (min + (max < 20 ? "–" + max : "+")));
      totEl.textContent = money(sum);
      saveEl.textContent = retail > sum && n > 0 ? fmt(T.saving, { x: money(retail - sum) }) : "";
      cta.disabled = n < min;
      cta.textContent = n < min ? fmt(T.chooseMore, { n: min - n }) : fmt(T.addSet, { n: n });
    }
    recompute();

    cta.addEventListener("click", function () {
      var chosen = Object.keys(qty).filter(function (k) { return qty[k] > 0; })
        .map(function (k) { return { id: k, qty: qty[k] }; });
      if (!chosen.length) return;
      cta.disabled = true;
      cta.textContent = T.adding;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: parentVariant, quantity: 1, properties: { _amh_bundle_items: JSON.stringify(chosen) } }] }),
      }).then(function (r) {
        if (!r.ok) throw new Error("add");
        window.location.href = "/cart";
      }).catch(function () { cta.disabled = false; recompute(); });
    });

    el.appendChild(wrap);

    // A clear "Choose your products" CTA placed where the (now hidden) add-to-cart button normally
    // sits, so customers aren't confused by a missing buy button. It scrolls to the picker grid.
    try {
      var scrollToPicker = function (ev) { if (ev) ev.preventDefault(); var t = document.querySelector(".amh-mixhero") || wrap || el; t.scrollIntoView({ behavior: "smooth", block: "start" }); };
      var existing = document.querySelector(".amh-choosecta");
      if (existing) {
        // The theme (custom-pdp-product-form) may already render the CTA button. It ships WITHOUT a
        // handler, so wire it here (idempotent — init() runs several times). Without this the button
        // does nothing and, on a long-description page, the picker below the fold is unreachable.
        if (!existing.__amhWired) { existing.__amhWired = 1; existing.addEventListener("click", scrollToPicker); }
      } else {
        var addForm = document.querySelector('form[action*="/cart/add"]:not(.amh-mix-form)');
        if (addForm) {
          var pick = document.createElement("button");
          pick.type = "button";
          pick.className = "amh-choosecta";
          pick.textContent = C.choose + " ↓";
          pick.__amhWired = 1;
          pick.addEventListener("click", scrollToPicker);
          addForm.parentNode.insertBefore(pick, addForm);
        }
      }
    } catch (e) { /* no cart form on this template — the picker's own CTA still applies */ }
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
})();
